import { gql } from "graphql-request";

import { DocumentType, SearchResult } from "../SearchResultRow/SearchResultRow.types";

import { BudgetFieldsFragment } from "./BudgetFieldsFragment";
import { ProposalFieldsFragment } from "./ProposalFieldsFragment";
import { WorksheetFieldsFragment } from "./WorksheetFieldsFragment";
import { WorkforceFieldsFragment } from "./WorkforceFieldsFragment";
import { AdjustmentLineFieldsFragment } from "./AdjustmentLineFieldsFragment";
import { StoryFieldsFragment } from "./StoryFieldsFragment";
import { PublicationFieldsFragment } from "./PublicationFieldsFragment";
import { ClassicReportFieldsFragment } from "./ClassicReportFieldsFragment";
import { NextGenCustomFieldsFragment } from "./NextGenCustomFieldsFragment";
import { NextGenStandardFieldsFragment } from "./NextGenStandardFieldsFragment";

export type SearchQueryResponse = {
  data: {
    searchAsync: SearchResult[];
  };
};

export type SearchQueryVariables = {
  query: string;
  documentType: DocumentType;
  entityId: number;
  budgetId?: number | null;
};

export const SEARCH_QUERY = gql`
  query Search($entityId: Int!, $query: String!, $documentType: DocumentType!, $budgetId: Int) {
    searchAsync(query: $query, entityId: $entityId, documentType: $documentType, budgetId: $budgetId) {
      __typename
      ...BudgetFieldsFragment
      ...ProposalFieldsFragment
      ...WorksheetFieldsFragment
      ...AdjustmentLineFieldsFragment
      ...WorkforceFieldsFragment
      ...StoryFieldsFragment
      ...PublicationFieldsFragment
      ...ClassicReportFieldsFragment
      ...NextGenCustomFieldsFragment
      ...NextGenStandardFieldsFragment
    }
  }
  ${BudgetFieldsFragment}
  ${ProposalFieldsFragment}
  ${WorksheetFieldsFragment}
  ${AdjustmentLineFieldsFragment}
  ${WorkforceFieldsFragment}
  ${StoryFieldsFragment}
  ${PublicationFieldsFragment}
  ${ClassicReportFieldsFragment}
  ${NextGenCustomFieldsFragment}
  ${NextGenStandardFieldsFragment}
`;

export const fetchSearchResultsQuery = async (
  variables: SearchQueryVariables,
  abortControllerSignal: AbortSignal,
): Promise<SearchQueryResponse["data"] | null> => {
  return fetch(`${window.location.origin}/api/og_assist_search/graphql`, {
    method: "POST",
    body: JSON.stringify({
      query: SEARCH_QUERY,
      variables,
    }),
    headers: {
      "content-type": "application/json",
    },
    signal: abortControllerSignal,
  })
    .then(async (response) => {
      if (!response.ok) throw new Error(`Response status: ${response.status}`);
      return (await response.json()) as Promise<{ data: SearchQueryResponse["data"] }>;
    })
    .then(({ data }) => data);
};
